import { CourseResponse, MyLearningStats } from "@/shared/types";
import api from "../api.client";
import { MyLearningBadgeResponse } from "@/shared/types/Badge";
const BASE_URL = "/my-learning";

const MyLearningService = {
  getCoursesPaginated: async (
    page: number,
    pageSize: number,
    status: 'pending' | 'in-progress' | 'completed',
    search: string = "",
    signal?: AbortSignal
  ): Promise<CourseResponse> => {
    const params = new URLSearchParams();
    params.append("page", String(page));
    params.append("pageSize", String(pageSize));
    params.append("status", String(status));
    if (search) params.append("search", search);

    const url = `${BASE_URL}/courses?${params.toString()}`;
    return api.get<CourseResponse>(url, { signal });
  },

  getStats: async (signal?: AbortSignal): Promise<MyLearningStats> => {
    const url = `${BASE_URL}/stats`;
    return api.get<MyLearningStats>(url, { signal });
  },

  getBadges: async (
    page: number,
    pageSize: number,
    search: string = "",
    signal?: AbortSignal
  ): Promise<MyLearningBadgeResponse> => {
    const params = new URLSearchParams();
    params.append("page", String(page));
    params.append("pageSize", String(pageSize));
    if (search) params.append("search", search);

    const url = `${BASE_URL}/badges?${params.toString()}`;
    return api.get<MyLearningBadgeResponse>(url, { signal });
  }

};

export default MyLearningService;
